import { ActivityFeed } from "@/components/stats/activity-feed";
import { PerformanceOverview } from "@/components/stats/performance-overview";
import { QuickActions } from "@/components/stats/quick-actions";
import { RecentProjects } from "@/components/stats/recent-projects";
import { RecentTemplates } from "@/components/stats/recent-templates";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/")({
  component: HomeRouteComponent,
});

function HomeRouteComponent() {
  return (
    <main className="p-4">
      <div className="mb-8">
        <h1 className="mb-2 bg-gradient-to-r from-white via-white to-gray-200 bg-clip-text text-4xl font-bold text-transparent">
          Welcome back, John!
        </h1>
        <p className="text-lg text-white/80">
          Here's what's happening with your templates and projects.
        </p>
      </div>

      <div className="space-y-6">
        <div>
          <h2 className="mb-4 text-xl font-semibold text-white/90">Quick Actions</h2>
          <QuickActions />
        </div>

        <div className="grid auto-rows-min grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          <div className="md:col-span-2 lg:col-span-2">
            <RecentProjects />
          </div>

          <div className="md:col-span-2 lg:col-span-1 xl:col-span-2">
            <RecentTemplates />
          </div>

          <div className="md:col-span-1 lg:col-span-2 xl:col-span-2">
            <ActivityFeed />
          </div>

          <div className="md:col-span-1 lg:col-span-1 xl:col-span-2">
            <PerformanceOverview />
          </div>
        </div>
      </div>
    </main>
  );
}
